import React, { useRef, useState } from 'react';
import TokenPicker from './TokenPicker';
import TokenChips from './TokenChips';
import { insertToken, buildToken, resolveTokens } from './tokenUtils';

// BL-080 — the inspector's personalizable content field. Resting state shows the
// text with tokens as chips (per the mockup's "no raw {{text}}" rule); clicking
// switches to a textarea for free editing. The { } button inserts a token at the
// caret. A live "Preview (sample values)" resolves the copy client-side.
//
// Controlled: `value` is the raw string ({{token}} form), `onChange(next)` saves it.
function PersonalizationContentField({ label = 'Content', value, onChange, minHeight }) {
  const [editing, setEditing] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);
  const taRef = useRef(null);
  const caretRef = useRef(null);

  const trackCaret = () => {
    if (taRef.current) caretRef.current = taRef.current.selectionStart;
  };

  const insert = (key) => {
    const token = buildToken(key);
    const caret = editing && caretRef.current != null ? caretRef.current : (value || '').length;
    const next = insertToken(value || '', token, caret);
    onChange(next);
    setPickerOpen(false);
    caretRef.current = caret + token.length;
  };

  return (
    <div className="un-pers-field">
      <p className="un-lab">{label}</p>
      <div className="un-fmtbar">
        <span className="un-fmtbar__sp" />
        <div className="un-tokwrap">
          <button type="button" className="un-tokbtn" onClick={() => setPickerOpen((o) => !o)}>
            {'{ }'} Insert personalization
          </button>
          <TokenPicker open={pickerOpen} onClose={() => setPickerOpen(false)} onInsert={insert} />
        </div>
      </div>

      {editing ? (
        <textarea
          ref={taRef}
          className="un-fmtarea"
          style={minHeight ? { minHeight } : undefined}
          defaultValue={value || ''}
          autoFocus
          onKeyUp={trackCaret}
          onClick={trackCaret}
          onChange={(e) => onChange(e.target.value)}
          onBlur={() => setEditing(false)}
        />
      ) : (
        <div
          className="un-fmtarea un-fmtarea--display"
          role="textbox"
          tabIndex={0}
          style={minHeight ? { minHeight } : undefined}
          onClick={() => setEditing(true)}
          onKeyDown={(e) => { if (e.key === 'Enter') setEditing(true); }}
        >
          {value ? <TokenChips text={value} /> : <span className="un-fmtarea__ph">Click to edit…</span>}
        </div>
      )}

      <div className="un-prev">
        <b>Preview (sample values)</b>
        {resolveTokens(value) || <span className="un-fmtarea__ph">Nothing yet</span>}
      </div>
    </div>
  );
}

export default PersonalizationContentField;
